export default __webpack_public_path__ + "static/media/failed-active.c4987b0f.svg";